/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuTypeaheadContainer_viewer = {|
  +isSearchWithinFilterEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeahead_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isSearchWithinFilterEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REFINE_MENU_SEARCH",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"REFINE_MENU_SEARCH\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
